import { Badge, BadgeProps, styled } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { useCafe } from '../contexts/cafe.context';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: 0,
    top: -1,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}));

const BookingsBadge: FC<PropsWithChildren> = ({ children }) => {
  const { unConfirmedReservations } = useCafe();

  if (!unConfirmedReservations.length) {
    return <div>{children}</div>;
  }

  return (
    <StyledBadge badgeContent={unConfirmedReservations.length} color="primary" max={9}>
      {children}
    </StyledBadge>
  );
};

export default BookingsBadge;
